import { render, staticRenderFns } from "./qualityPrintbatchQuery.vue?vue&type=template&id=28f96f66&scoped=true"
import script from "./qualityPrintbatchQuery.vue?vue&type=script&lang=js"
export * from "./qualityPrintbatchQuery.vue?vue&type=script&lang=js"
import style0 from "./qualityPrintbatchQuery.vue?vue&type=style&index=0&id=28f96f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f96f66",
  null
  
)

export default component.exports